// extracted by mini-css-extract-plugin
module.exports = {"rootskiIntro":"cliff-and-intro_rootskiIntro__1GRiT","cliffSVG":"cliff-and-intro_cliffSVG__1Svb_"};